import { Button, Checkbox, Form, Input, message, Spin } from "antd";
import { useState } from "react";
import './auth.css';
import { useDispatch } from "react-redux";
import { serverFetch } from "../../server";
import { userLoaded } from "../../redux/actions";
import EnterCode from "../../controls/enter-code/enter-code";

const PROMO_BENEFITS = [
  "Управление клиентами, продажами и платежами",
  "Расписание, склад и система контроля доступа",
  "Виджеты, диалоги ИИ и аналитика в реальном времени",
];

const PROMO_STATS = [
  { label: "Клиентов", value: "10k+" },
  { label: "Записей в месяц", value: "15k" },
  { label: "Рост эффективности", value: "+25%" },
];

const mailIcon = (
  <span className="auth-input-icon">
    <img src="/images/auth/mail.svg" alt="" width={18} height={18} />
  </span>
);

const Auth = () => {
  const d = useDispatch();
  const [form] = Form.useForm();
  const [data, setData] = useState({email: '', checkcode: '', name: ''})
  const [sentCode, setSentCode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [codeId, setCodeId] = useState();
  const [register, setRegister] = useState(false);
  const [agree1, setAgree1] = useState(false);
  const [agree2, setAgree2] = useState(false);

  const onFinish = () => {}
  const onSendCode = () => {
    setLoading(true);
    serverFetch(`auth/GenerateCheckcode?email=${data.email}&register=${register}&name=${data.name}`)
      .then((data) => {
        setSentCode(true);
        setLoading(false);
        setCodeId(data);
      })
      .catch(e => {
        message.error(e.userMessage);
        setLoading(false);
      });
  }
  const onChangeValue = (value) => {
    setData({...data, ...value});
  }
  const onLogin = (data) => {
    setLoading(true);
    serverFetch('auth/login', {method: 'POST', bodyData: data})
      .then(session => d(userLoaded(session)))
      .catch(e => {
        message.error(e.userMessage);
        setLoading(false);
      });
  }
  const onEnterCode = (checkcode) => {
    const newData = {...data, checkcode, id: codeId};
    setData(newData);
    onLogin(newData);
  }
  const switchMode = (nextRegister) => {
    setRegister(nextRegister);
    setSentCode(false);
    setAgree1(false);
    setAgree2(false);
  }

  const agree = agree1 && agree2 && data.name && data.email;

  return (
    <div className="auth-body">
      <div className="auth-promo">
        <img className="auth-promo-bg" src="/images/auth/promo.png" alt="" />
        <div className="auth-promo-overlay" />
        <div className="auth-promo-content">
          <h1 className="auth-promo-title">Облачная платформа для бизнеса в сфере услуг</h1>
          <div className="auth-promo-benefits">
            {PROMO_BENEFITS.map((text) => (
              <div className="auth-promo-benefit" key={text}>
                <span className="auth-promo-check">
                  <img src="/images/auth/check.svg" alt="" width={18} height={18} />
                </span>
                <p>{text}</p>
              </div>
            ))}
          </div>
          <div className="auth-promo-stats">
            {PROMO_STATS.map((stat) => (
              <div className="auth-promo-stat" key={stat.label}>
                <span className="auth-promo-stat-label">{stat.label}</span>
                <span className="auth-promo-stat-value">{stat.value}</span>
              </div>
            ))}
          </div>
          <p className="auth-promo-trial">Попробуйте бесплатно 20 дней. Без карты, без обязательств.</p>
        </div>
      </div>

      <div className="auth-panel">
        <div className="auth-panel-inner">
          <div className="auth-brand">
            <img src="/images/logo.svg" className="auth-logo" alt="Профитоник" />
            <div className="auth-brand-name">ПРОФИТОНИК</div>
          </div>

          <Spin spinning={loading}>
            <div className="auth-form">
              <div className="auth-form-title">{register ? "РЕГИСТРАЦИЯ" : "ВХОД"}</div>
              <Form form={form} initialValues={{ remember: true }} onFinish={onFinish}>
                {register && (
                  <div className="auth-field">
                    <label className="auth-field-label" htmlFor="auth-name">Наименование клуба</label>
                    <Form.Item className="auth-form-item" name="name">
                      <Input
                        id="auth-name"
                        placeholder="Наименование клуба"
                        disabled={loading || sentCode}
                        className="auth-form-item-input"
                        onChange={(e) => onChangeValue({name: e.target.value})}
                      />
                    </Form.Item>
                  </div>
                )}
                <div className="auth-field">
                  <label className="auth-field-label" htmlFor="auth-email">Почта</label>
                  <Form.Item className="auth-form-item" name="email">
                    <Input
                      id="auth-email"
                      prefix={mailIcon}
                      placeholder="your@email.com"
                      disabled={loading || sentCode}
                      className="auth-form-item-input"
                      onChange={(e) => onChangeValue({email: e.target.value})}
                    />
                  </Form.Item>
                </div>
                {register && !sentCode && (
                  <>
                    <Form.Item className="auth-checkbox-item">
                      <Checkbox checked={agree1} onChange={(e) => setAgree1(e.target.checked)}>
                        Принимаю <a href="https://profitonik.ru/user_agreement" target="_blank" rel="noreferrer">пользовательское соглашение</a>
                      </Checkbox>
                    </Form.Item>
                    <Form.Item className="auth-checkbox-item">
                      <Checkbox checked={agree2} onChange={(e) => setAgree2(e.target.checked)}>
                        Принимаю <a href="https://profitonik.ru/privacy_policy" target="_blank" rel="noreferrer">политику конфиденциальности</a>
                      </Checkbox>
                    </Form.Item>
                  </>
                )}
                {sentCode || (
                  <Form.Item className="auth-form-item auth-form-item-btn">
                    <Button
                      type="primary"
                      loading={loading}
                      className={"auth-form-btn" + (register && !agree ? " auth-btn-disabled" : "")}
                      onClick={onSendCode}
                      disabled={register && !agree}
                    >
                      Отправить код
                    </Button>
                    {register && (
                      <div className="auth-form-help-link">
                        <a href="https://kb.sport24.cloud/article/registraciya-i-ustanovka-programmnogo-obespecheniya" target="_blank" rel="noreferrer">Регистрация и установка</a>
                        <a href="https://kb.sport24.cloud/article/funkcionalnye-harakteristiki" target="_blank" rel="noreferrer">Функциональные характеристики</a>
                      </div>
                    )}
                  </Form.Item>
                )}
                {!loading && sentCode && (
                  <>
                    <Form.Item className="auth-form-item">
                      <div className="auth-enter-code-title">ВВЕДИТЕ КОД</div>
                    </Form.Item>
                    <Form.Item className="auth-form-item">
                      <EnterCode len={6} onFinish={onEnterCode} />
                    </Form.Item>
                  </>
                )}
              </Form>
            </div>
          </Spin>

          {register ? (
            <div className="auth-create">
              Есть учетная запись?
              <div className="auth-create-link" onClick={() => switchMode(false)}>Войти</div>
            </div>
          ) : (
            <div className="auth-create">
              Нет учетной записи?
              <div className="auth-create-link" onClick={() => switchMode(true)}>Создать</div>
            </div>
          )}
        </div>
        <div className="auth-legal">© 2026 Компания Проффит</div>
      </div>
    </div>
  )
}

export default Auth;
